import { objectMap } from 'utils'
import coldBlue from './cold-blue'
import brightBlue from './bright-blue'
import raspberry from './raspberry'
import darkRed from './dark-red'
import purpleMint from './purple-mint'
import pastels from './pastels'
import candy from './candy'
import contrastOlive from './contrast-olive'
import mojito from './mojito'

// https://bitbucket.org/strcdrs/b2b-admin/src/master/public/theme/adultreact/colorthemes/

export const colorThemes = {
  coldBlue,
  brightBlue,
  raspberry,
  darkRed,
  purpleMint,
  pastels,
  candy,
  contrastOlive,
  mojito,
}

const themeNames = Object.keys(colorThemes)

const themes = objectMap(colorThemes, colors => ({
  iconSet: '1',
  roundness: '1',
  fonts: {
    url:
      'https://fonts.googleapis.com/css?family=Lato:300,300i,400,400i,700,700i,900,900i|Open+Sans:300,300i,400,400i,600,600i,700,700i&subset=cyrillic,cyrillic-ext,greek,greek-ext,latin-ext',
    names: { title: 'Lato, sans-serif', body: 'Open Sans, sans-serif' },
  },
  colors,
}))

window.themes = colorThemes

window.theme = {
  clear: () => {
    delete sessionStorage.theme
    location.reload()
  },
  edit: (value = 1) => {
    sessionStorage.themeEditor = value
    window.store.dispatch({ type: 'SET_FLAG', data: { key: 'themeEditor', value: value } })
  },
  preview: (value = 1) => {
    sessionStorage.themePreview = value
    window.store.dispatch({ type: 'SET_FLAG', data: { key: 'themePreview', value: value } })
    let names = 'Emelia Betty Lilly Troy Tanya Sofia Holly Casey Nadia Sara Rachael Faye Julia Megan Katherine Anya Veronica Maddie Stella Martha Hannah Claudia Marina Nina Maria Irene Janet Natasha Lidia'.split(
      ' '
    )
    const used = {}
    document.querySelectorAll('a[href*="/members/"]').forEach(a => {
      const name = a.querySelector('.username')
      const nick = +a.href.replace(/.*\//, '')
      name.textContent = used[nick] = used[nick] || names[nick % names.length]
      names = names.filter(e => e != used[nick])
    })
  },
  next: () => {
    const name = themeNames[(themeNames.indexOf(sessionStorage.theme) + 1) % themeNames.length]
    window.theme[name]()
    return name
  },
  siteStyles: () => {
    delete sessionStorage.theme
    window.store.dispatch({ type: 'CHANGE_THEME', payload: JSON.parse(sessionStorage.siteStyles) })
  },
  ...objectMap(themes, (value, name) => () => {
    sessionStorage.theme = name
    window.store.dispatch({ type: 'CHANGE_THEME', payload: value })
  }),
  roundness: value => {
    sessionStorage.roundness = value
    window.store.dispatch({ type: 'CHANGE_THEME', payload: { roundness: value } })
  },
}

export default themes[sessionStorage.theme || 'coldBlue']
